import React from 'react';

interface LightningBoltProps {
  className?: string;
  style?: React.CSSProperties;
}

export const LightningBolt = ({ className = "w-5 h-5", style }: LightningBoltProps) => {
  return (
    <svg
      viewBox="0 0 105 230"
      className={className}
      style={style}
    >
      {/* Yellow lightning bolts */}
      <g>
        <polygon fill="#FFDC00" points="15.7,11.7 34.2,56.1 10.7,56.1 18.4,75.7 66.1,75.7" />
        <polygon fill="#FFDC00" points="78.3,173.6 70.5,154 59.6,154 36.9,99 27.1,99 49.8,154 22.1,154 73.3,218.1 54.8,173.6" />
      </g>

      {/* White elements */}
      <g>
        <path fill="#FFFFFF" d="M84.6,95.3c0.6,0,1.9-0.7,1.9-7.5c0-6.8-1.3-7.5-1.9-7.5H51.9l6.2,15.1H84.6z"/>
        <path fill="#FFFFFF" d="M65.5,113.4l22,0c0.6,0,1.9-0.7,1.9-7.5s-1.3-7.5-1.9-7.5l-28.3,0L65.5,113.4z"/>
        <path fill="#FFFFFF" d="M84.6,134.5H55l6.2,15.1h23.4c0.6,0,1.9-7.5,1.9-7.5C86.6,135.2,85.2,134.5,84.6,134.5z"/>
        <path fill="#FFFFFF" d="M87.6,116.4h-40l6.2,15.1h33.8c0.6,0,1.9-0.7,1.9-7.5C89.5,117.1,88.2,116.4,87.6,116.4z"/>
        <path fill="#FFFFFF" d="M29.4,113.5l-7-18.2h16.4l7.6,18.2l15.7-0.1L48.5,80.2H14.3c-2.6,0-4.1,0-5.3,3.9c-1.4,4.7-1.6,13.5-1.6,30.7
            c0,17.2,0.2,26,1.6,30.7c1.2,3.9,2.6,3.9,5.3,3.9l30,0l-14.9-36.1L29.4,113.5z"/>
        <path fill="#FFFFFF" d="M92,145.6h-1.2v-0.8h3.5v0.8H93v3.6h-1V145.6z M96.8,149.2l-1.1-3.4v3.4h-0.9v-4.4h1.3l1.1,3.4l1.1-3.4h1.3
            v4.4h-0.9v-3.4l-1.1,3.4H96.8z"/>
      </g>
    </svg>
  );
};
